'use strict';

export const version: string = '0.0.51';
// Prova de Certificação
export const applicationId: number = 4;
export const emailPW: string = 'oi@email.com';
export const passPW: string = 'aQmws5NJuMLH6TJrzUpWT3qguJwMdUmsksZyYzsqHwN6TMREfs';

//export const tokenPS: string = '774D9CB1F5724573A3788DDEEE088808';
//export const emailPS: string = 'cintia@institutototum.com.br';

export const tokenPS: string = '92061453-55a3-4e75-a217-0f3d53eea53ce1afd294445da29eaad20a9aa051fb1c43be-371a-43f3-9328-44c501ad1cdc';
export const emailPS: string = 'cintia@institutototum.com.br';
export const baseUrlGateway: string = 'https://paygtw.institutototum.com.br/api/';

export const urlIp: string = 'https://httpbin.org/ip';
export const installmentsQuantity: number = 0;

const _hostName = window.location.hostname;
const _hostUrl = window.location.href;
let _company: string = null;
let _baseUrl: string = null;
let _certificatedUrl: string = null;
let _proofId: number = null;
let _baseUrlGateway: string = null;
let _installmentsURL: string = null;
let _quizzEnabled: boolean = true;
let _quizzProofId: number = null;

switch (_hostName) {

  // Teste & Desenvolvimento
  case 'rpps.certificaonline.institutototum.com.br':
    _baseUrl = 'https://api.rpps.certificaonline.institutototum.com.br';
    _baseUrlGateway = 'https://paygtw.institutototum.com.br/api/';
    _certificatedUrl = 'https://teste.certificated.certificaonline.institutototum.net.br';
    _installmentsURL = 'https://pagseguro.uol.com.br/checkout/v2/installments.json?';
    _proofId = 3;
    _quizzProofId = 73;
    break;


  // Localhost -livereload ionic
  case 'localhost':
    _baseUrl = 'https://stg.api.febraban.institutototum.com.br';
    // _baseUrlGateway = 'https://paygtw.institutototum.net.br/api/';
    // _certificatedUrl = 'https://certificated.certificaonline.institutototum.com.br';
    // _installmentsURL = 'https://pagseguro.uol.com.br/checkout/v2/installments.json?';
    // _proofId = 3;
    // _quizzProofId = 73;
    _company = 'FEBRABAN';
    // _baseUrl = '/api';
    _baseUrlGateway = 'https://paygtw.institutototum.com.br/api/';
    _certificatedUrl = 'https://stg.certificated.certificaonline.institutototum.com.br';
    _installmentsURL = 'https://pagseguro.uol.com.br/checkout/v2/installments.json?';
    _proofId = 3;
    _quizzProofId = 73;
    break;
  case 'stg.febraban.institutototum.com.br':
    _baseUrl = 'https://stg.api.febraban.institutototum.com.br';
    _certificatedUrl = 'https://certificated.certificaonline.institutototum.com.br';
    _installmentsURL = 'https://pagseguro.uol.com.br/checkout/v2/installments.json?';
    _baseUrlGateway = 'https://paygtw.institutototum.com.br/api/';
    _proofId = 3;
    _quizzProofId = 73;
    break;

  // Producao
  default:
    _baseUrl = 'https://api.febraban.institutototum.com.br';
    _certificatedUrl = 'https://certificated.certificaonline.institutototum.com.br';
    _installmentsURL = 'https://pagseguro.uol.com.br/checkout/v2/installments.json?';
    _baseUrlGateway = 'https://paygtw.institutototum.com.br/api/';
    _proofId = 3;
    _quizzProofId = 73;
}

export const proofId = _proofId;
export const company = _company;
export const baseUrl = _baseUrl;
export const hostUrl = _hostUrl;
export const certificatedUrl = 'https://adminapi.rpps.certificaonline.institutototum.com.br';
//_certificatedUrl;
//export const baseUrlGateway = _baseUrlGateway;
export const installmentsURL = _installmentsURL;
export const quizzEnabled = _quizzEnabled;
export const quizzProofId = _quizzProofId;

console.log('baseUrl--->' + baseUrl);
console.log('hostUrl--->' + hostUrl);
console.log('baseUrlGateway--->' + baseUrlGateway);
console.log('installmentsURL--->' + installmentsURL);
console.log('quizzEnabled--->' + quizzEnabled);
console.log('quizzProofId--->' + quizzProofId);



// WEBPACK FOOTER //
// ./src/app/app.config.ts